import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    user: null,                 // User data of logged in user
    token: null,                // Token ID
    mode: 'designer',           // Application mode designer, editor, preview
    show: null,                 // What templates to show on load
    cat: null,                  // What category to show
    config: {
        hideSideNav: true
    },
    templateList: null,         // Full list of templates pulled from url
    fonts: [],                  // What fonts are available
    activeFonts: [],            // What fonts are active in the current template
    fontsLoadedFor: null,       // What template uuid the current loaded fonts belong to
    savedTemplate: null,        // Saved template data injected into parent template
    templateName: null,         // Name of the saved template
    template: null,             // Full template data
    activeTemplate: null,       // File side of the active template (front, back, etc)
    templateChanges: false,     // Have changes been made to the template (bool)
    pickerUrl: null,            // Last called url to fetch templates list
    pageUrl: 'https://www.primoprint.com/', // Parent Page URL (calling the iframe)
    pickerPage: 1,              // Current page id of template list
    pickerState: {              // Current state of filtering for template list
        category: null,
        size: null,
        spot_uv: null,
        foil: null,
        color: null
    }
}

const mutations = {
    user (user, data) {
        this.state.user = data
    },
    token (token, data) {
        this.state.token = data
    },
    mode (mode, data) {
        this.state.mode = data
    },
    show (show, data) {
        this.state.show = data
    },
    cat (cat, data) {
        this.state.cat = data
    },
    templateList (templateList, data) {
        this.state.templateList = data
    },
    fonts (fonts, data) {
        this.state.fonts = data
    },
    activeFonts (activeFonts, data) {
        this.state.activeFonts = data
    },
    fontsLoadedFor (fontsLoadedFor, data) {
        this.state.fontsLoadedFor = data
    },
    template (template, data) {
        this.state.template = data
    },
    savedTemplate (savedTemplate, data) {
        this.state.savedTemplate = data
    },
    activeTemplate (activeTemplate, data) {
        this.state.activeTemplate = data
    },
    templateName (templateName, data) {
        this.state.templateName = data
    },
    templateChanges (templateChanges, data) {
        this.state.templateChanges = data
    },
    pickerUrl (pickerUrl, data) {
        this.state.pickerUrl = data
    },
    pageUrl (pageUrl, data) {
        this.state.pageUrl = data
    },
    pickerPage (pickerPage, data) {
        this.state.pickerPage = data
    },
    pickerState (pickerState, data) {
        this.state.pickerState = data
    },
    config (config, data) {
        this.state.config = data
    }
}

export default new Vuex.Store({
    state,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js